import * as React from 'react';
import Image from 'next/image';

type IAboutProps = object;

const AboutFour: React.FunctionComponent<IAboutProps> = () => {
  return (
    <section id='about' className='pb-20 lg:pb-25 xl:pb-30 overflow-hidden pt-30'>
      {/* Header added here */}
      <h1 className='text-black text-4xl xl:text-hero font-bold mb-10 pl-25'>
        Instantly schedule meetings{' '}
      </h1>
      <h4 className='text-black text-lg font-medium mb-5 pl-25'>
        Allow your buyers to schedule meetings
      </h4>
      <div className='mx-auto max-w-c-1235 px-4 md:px-8 xl:px-0'>
        <div className='flex items-center gap-8 lg:gap-32.5'>
          <div className='animate_left hidden md:block md:w-1/2'>
            <Image src='/images/products/scheduling/AIScheduling.png' alt='About' width={600} height={400} />
          </div>
          <div className='animate_right md:w-1/2'>
            <h4 className='text-black  font-medium uppercase'>Book more meetings with prospects</h4>
            <h2 className='relative font-bold text-black  text-3xl xl:text-hero mb-6'>
              Boost your{' '}
              <span className='inline-block relative before:absolute before:bottom-2.5 before:left-0 before:w-full before:h-3 before:bg-titlebg before:-z-1'>
                pipeline
              </span>
            </h2>
            <p>Dont show your buyers a long form:</p>
            <ul className='list-disc list-inside'>
              <li>Direct access to sales rep calendar</li>
              <li>Buyers can see availability</li>
              <li>Restricted to verified business emails</li>
            </ul>
          </div>
        </div>
      </div>
      <div className='mx-auto max-w-c-1235 px-4 md:px-8 2xl:px-0 pt-30'>
        <div className='flex items-center gap-8 lg:gap-32.5'>
          <div className='animate_left md:w-1/2'>
            <h4 className='text-black font-medium uppercase'>Microsoft 365/ Google Workplace</h4>
            <h2 className='relative font-bold text-black text-3xl xl:text-hero mb-6'>
              Close the deal right from your{' '}
              <span className='inline-block relative before:absolute before:bottom-2.5 before:left-0 before:w-full before:h-3 before:bg-titlebg2 before:-z-1'>
                Website
              </span>
            </h2>
            <p>Bypass 15 field web forms:</p>
            <ul className='list-disc list-inside'>
              <li>Out of the box integration</li>
              <li>Sends your dial information automatically</li>
              <li>Verified buyer access only</li>
            </ul>
          </div>
          <div className='animate_right hidden md:block md:w-1/2'>
            <Image src='/images/products/scheduling/AICalendar.png' alt='About' width={600} height={400} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutFour;
